export enum LivePollLisStarred {
  UN_STARRED = 0,
  STARRED = 1,
}
